import React from 'react';
import CodeBlock from '../components/CodeBlock';

const Contacts = () => {
  return (
    <div className="page">
      <div className="page-header">
        <h1>👤 Contacts</h1>
        <p>
          Endpoints CRUD pour gérer les contacts de votre workspace.
          Tous les endpoints sont sous <code>/api/v1/contacts</code> et requièrent un JWT (Bearer)
          + le header <code>X-Workspace-Id</code>.
        </p>
      </div>

      <div className="section">
        <h2>Lister les contacts</h2>
        <div className="endpoint-card">
          <div className="endpoint-header">
            <span className="method-badge method-get">GET</span>
            <span className="endpoint-path">/api/v1/contacts</span>
          </div>
          <div className="endpoint-description">Liste paginée avec recherche et filtres.</div>

          <h4>Query parameters</h4>
          <table className="params-table">
            <thead><tr><th>Param</th><th>Type</th><th>Description</th></tr></thead>
            <tbody>
              <tr><td><code>limit</code></td><td>int</td><td>Nombre max d'items (1-200, défaut 50)</td></tr>
              <tr><td><code>offset</code></td><td>int</td><td>Décalage pour pagination (défaut 0)</td></tr>
              <tr><td><code>search</code></td><td>string</td><td>Recherche dans nom/téléphone/email</td></tr>
              <tr><td><code>blacklisted</code></td><td>bool</td><td>Filtre les contacts blacklistés</td></tr>
            </tbody>
          </table>

          <CodeBlock language="bash" code={`curl -X GET "https://api.whakup.com/api/v1/contacts?limit=50&search=jean" \\
  -H "Authorization: Bearer YOUR_JWT" \\
  -H "X-Workspace-Id: 42"`} />

          <h4>Réponse 200</h4>
          <CodeBlock language="json" code={`{
  "data": [
    {
      "id": 1234,
      "phone": "+33612345678",
      "firstName": "Jean",
      "lastName": "Dupont",
      "email": "jean@example.com",
      "blacklisted": false,
      "groups": [{"id": 5, "title": "Clients VIP"}]
    }
  ],
  "pagination": { "limit": 50, "offset": 0, "total": 1247 }
}`} />
        </div>
      </div>

      <div className="section">
        <h2>Créer ou mettre à jour un contact</h2>
        <div className="endpoint-card">
          <div className="endpoint-header">
            <span className="method-badge method-post">POST</span>
            <span className="endpoint-path">/api/v1/contacts</span>
          </div>
          <div className="endpoint-description">
            Si un contact avec le même téléphone existe déjà → met à jour.
            Sinon → crée. Le téléphone est normalisé en E164.
          </div>

          <h4>Body</h4>
          <CodeBlock language="json" code={`{
  "phone": "+33612345678",
  "firstName": "Jean",
  "lastName": "Dupont",
  "email": "jean@example.com",
  "groups": [{ "id": 5 }]
}`} />

          <h4>Réponse 201</h4>
          <CodeBlock language="json" code={`{
  "data": {
    "id": 1234,
    "phone": "+33612345678",
    "firstName": "Jean",
    "lastName": "Dupont",
    "email": "jean@example.com"
  }
}`} />

          <div className="alert alert-info" style={{ marginTop: '1rem' }}>
            💡 Cet endpoint déclenche les événements webhook <code>contact.created</code> ou <code>contact.updated</code>.
          </div>
        </div>
      </div>

      <div className="section">
        <h2>Récupérer / Modifier / Supprimer</h2>

        <div className="endpoint-card">
          <div className="endpoint-header">
            <span className="method-badge method-get">GET</span>
            <span className="endpoint-path">/api/v1/contacts/{'{id}'}</span>
          </div>
        </div>

        <div className="endpoint-card">
          <div className="endpoint-header">
            <span className="method-badge method-put">PUT</span>
            <span className="endpoint-path">/api/v1/contacts/{'{id}'}</span>
          </div>
          <div className="endpoint-description">Body identique à la création.</div>
        </div>

        <div className="endpoint-card">
          <div className="endpoint-header">
            <span className="method-badge method-delete">DELETE</span>
            <span className="endpoint-path">/api/v1/contacts/{'{id}'}</span>
          </div>
          <div className="endpoint-description">
            Déclenche le webhook <code>contact.deleted</code> avec un snapshot pré-suppression.
          </div>
        </div>
      </div>

      <div className="section">
        <h2>Scope requis</h2>
        <p>
          Pour utiliser ces endpoints avec une API Key, votre clé doit avoir au moins un des scopes :
        </p>
        <ul>
          <li><code>contacts:read</code> — pour <code>GET</code></li>
          <li><code>contacts:write</code> — pour <code>POST</code>, <code>PUT</code>, <code>DELETE</code></li>
        </ul>
      </div>
    </div>
  );
};

export default Contacts;
